export default __webpack_public_path__ + "assets/0963a5443de8ff1e88f0889bb01c5249.svg";